import { boutonFiltreFaqMock, listingFaqMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [boutonFiltreFaqMock(), listingFaqMock()];

export const faqListingMock: SlugPage = {
  ...pageBase({
    title: 'Faq Listing',
    type: 'faq',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
